import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import useMeasure from 'react-use-measure';
import { Sheet } from 'frontend/js/modules/infra/dls/components/sheet/sheet';
import { t } from '../../../../infra/i18n';
import { DatepickerBase } from './datepicker-base';
import styles from './styles.module.scss';
import { Button } from '../../../../infra/dls/components/button/button';
import { TextS } from '../../../../infra/dls/components/typography/typography';
import { useBreakpoints } from '../../../../infra/dls/hooks/use-get-breakpoints';
import { useDropdownPosition } from '../../../../infra/dls/hooks/use-dropdown-position';
export var DatepickerContent = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, isOpen = _a.isOpen, onClick = _a.onClick, onChange = _a.onChange, value = _a.value, minDate = _a.minDate, maxDate = _a.maxDate, triggerRef = _a.triggerRef, dateFormat = _a.dateFormat;
    var _b = useMeasure(), contentRef = _b[0], contentBounds = _b[1];
    var isMobileOrSmaller = useBreakpoints().isMobileOrSmaller;
    var _c = useState(), temporaryDateValue = _c[0], setTemporaryDateOption = _c[1];
    var _d = useState(''), localSelectErrorMessage = _d[0], setLocalSelectErrorMessage = _d[1];
    var dropdownPosition = useDropdownPosition(isOpen, triggerRef.current, contentBounds, 'bottom', 'start', 'auto', false);
    var handleSelectDate = function (newValue) {
        if (!newValue)
            return;
        if (isMobileOrSmaller) {
            setTemporaryDateOption(newValue);
        }
        else {
            onChange(newValue);
            onClick();
        }
    };
    var handleConfirmDateSelection = function () {
        if (!temporaryDateValue) {
            setLocalSelectErrorMessage(t('engage:datepicker.please_select_date'));
            return;
        }
        onClick();
        onChange(temporaryDateValue);
    };
    // reset on unmount
    useEffect(function () {
        return function () {
            setLocalSelectErrorMessage('');
            setTemporaryDateOption(undefined);
        };
    }, [isOpen]);
    if (isMobileOrSmaller) {
        return (_jsxs(Sheet, { open: isOpen, onClose: onClick, title: title, children: [_jsx("div", { className: styles['sheet-content'], children: _jsx(DatepickerBase, { dateFormat: dateFormat, onSelectDate: handleSelectDate, value: temporaryDateValue || value, minDate: minDate, maxDate: maxDate }) }), _jsxs(Sheet.Subtitle, { children: [subtitle && _jsx(TextS, { color: "secondary", children: subtitle }), localSelectErrorMessage && _jsx(TextS, { color: "negative", children: localSelectErrorMessage })] }), _jsx(Sheet.Actions, { children: _jsx(Button, { fullWidth: true, onClick: handleConfirmDateSelection, children: t('engage:datepicker.select') }) })] }));
    }
    if (!isOpen || !dropdownPosition)
        return null;
    return ReactDOM.createPortal(
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    _jsx("div", { ref: contentRef, className: styles.content, style: dropdownPosition, onMouseDown: function (e) { return e.stopPropagation(); }, children: _jsx(DatepickerBase, { onSelectDate: handleSelectDate, value: value, minDate: minDate, maxDate: maxDate, dateFormat: dateFormat }) }), document.getElementById('app-modals-portal'));
};
